import React, { useState } from 'react';

// "Ask for more" — sits at the end of the Bible reader. A reader who wants a passage
// that isn't in the highlights (or wants one recorded rather than silent) says so here.
// It composes a mail to the project rather than posting to a server: the static build has
// no backend, and this way the request reaches a person even if nothing is deployed.
const TO = 'shidailun@gmail.com';

export default function RequestPassage({ textTitle = '聖經選讀' }) {
  const [open, setOpen] = useState(false);
  const [passage, setPassage] = useState('');
  const [why, setWhy] = useState('');
  const [who, setWho] = useState('');
  const [sent, setSent] = useState(false);

  const send = () => {
    if (!passage.trim()) return;
    const subject = `【${textTitle}】想讀的經文：${passage.trim()}`;
    const body = [
      `想讀的經文：${passage.trim()}`,
      why.trim() ? `原因／說明：${why.trim()}` : '',
      who.trim() ? `提出的人：${who.trim()}` : '',
      '',
      '（由3S4T賽德克語聖經送出）',
    ].filter(Boolean).join('\n');
    window.location.href =
      `mailto:${TO}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    setSent(true);
  };

  if (!open) {
    return (
      <div className="req-wrap">
        <p className="req-lead">找不到想讀的經文嗎？</p>
        <button className="req-open" onClick={() => setOpen(true)}>申請加入經文</button>
      </div>
    );
  }

  return (
    <div className="req-wrap">
      <div className="req-card">
        <h4 className="req-h">申請加入經文</h4>
        <p className="req-p">告訴我們想讀哪一段（例如「創世記 22 章：亞伯拉罕獻以撒」）。</p>

        <label className="req-label">想讀的經文</label>
        <input className="req-input" value={passage} autoFocus
          onChange={(e) => setPassage(e.target.value)}
          placeholder="書卷、章節，或故事名稱" />

        <label className="req-label">原因／說明（可不填）</label>
        <textarea className="req-textarea" value={why} rows={3}
          onChange={(e) => setWhy(e.target.value)}
          placeholder="為什麼想讀這一段？教會常用？想聽錄音？" />

        <label className="req-label">您的稱呼（可不填）</label>
        <input className="req-input" value={who}
          onChange={(e) => setWho(e.target.value)} placeholder="姓名或稱呼" />

        <div className="req-row">
          <button className="req-send" onClick={send} disabled={!passage.trim()}>送出申請</button>
          <button className="req-cancel" onClick={() => { setOpen(false); setSent(false); }}>取消</button>
        </div>
        {sent && <p className="req-ok">已開啟郵件，請按寄送完成申請。謝謝！</p>}
      </div>
    </div>
  );
}
